var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5D8C0637Bf01Fa95Bf1C56667Ec6Dec3A9B9A0B0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 340 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    y1: 0.5,
    x2: 340,
    y2: 0.5,
    stroke: "var(--stroke-0, #D5DBEA)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5D8C0637Bf01Fa95Bf1C56667Ec6Dec3A9B9A0B0);
export default __webpack_public_path__ + "static/media/5d8c0637bf01fa95bf1c56667ec6dec3a9b9a0b0.1bba60a62a7754f4341b22bce80d8000.svg";
export { ForwardRef as ReactComponent };